<template>
  <section class="our-story">
    <div class="our-story__content container">
      <div class="our-story__text">
        <h3 class="our-story__subtitle --fade-in-left" data-vertical-ivp-class="--animate">OUR STORY</h3>
        <h1 class="our-story__title">
          Elevate Trust. Inspire Confidence.
        </h1>
        <p class="our-story__description">
          Our goal is to elevate trust in cannabis and inspire confidence in the
          plant across consumers, patients, investors and entrepreneurs alike. 
          <br /><br />
          This inspired confidence and why for cannabis is different for everyone.
          For most, it hits close to home, including our own Andrew Bowden,
          an investor first, and now CEO.
          <br /><br />
          When Andrew Bowden’s mother was diagnosed with triple-negative stage 3 breast
          cancer in 2016, he began searching for something to help her eat
          and sleep through the pain from treatment.
          <br /><br />
          Thanks to the support of her family, her determination, and Item 9 Labs
          product, she survived three different, arduous routes of cancer treatment.
          <br /><br />
          Seeing the positive effects cannabis had on his mother’s battle with breast
          cancer, Bowden joined Item 9 Labs Corp. as a board member in 2018 and was
          appointed to CEO in 2019. His goal is to give the same opportunities
          to others who need help.
          <br /><br />
          “Cannabis is truly a medicine,” said Bowden. “This is what will help
          future cancer patients thrive and enjoy the rest of their lives.
          I want to see everyone live life to their fullest, pain free.”
          <br /><br />
          Since Bowden’s appointment to CEO, Item 9 Labs Corp. has seen nine
          consecutive quarters of revenue growth. And, his mother, Mary,
          is now five years cancer free.
        </p>
        <div class="our-story__btn">
          <a class="button-outlined --text-dark"
              href="https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view"
              target="_blank">
            <div class="text">Invest Now</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
        </div>
      </div>
      <div class="our-story__images">
        <div class="our-story__img-container">
          <img src="../assets/our-story/img-1.jpeg" />
        </div>
        <div class="our-story__img-container">
          <img src="../assets/our-story/img-2.png" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "OurStory",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/OurStory.scss";
</style>
